import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { UserIdleModule } from 'angular-user-idle';

import { AngularCommonModule } from '../angular-common/angular-common.module';

import { CoreRoutingModule } from './core-routing.module';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { HomeComponent } from './components/home/home.component';

import { AuthGuard } from './guards/auth.guard';

import { SessionExpiredComponent } from './components/session-expired/session-expired.component';
import { ManualLoginComponent } from './components/manual-login/manual-login.component';

import { environment } from '../../environments/environment';
import { SharedModule } from '../shared/shared.module';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { RollbarErrorHandler, RollbarService, rollbarFactory } from './services/rollbar';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    CoreRoutingModule,
    AngularCommonModule,
    UserIdleModule.forRoot({ idle: environment.idle, timeout: environment.timeout, ping: 60 })
  ],
  exports: [
    RouterModule
  ],
  declarations: [NotFoundComponent, HomeComponent, SessionExpiredComponent, ManualLoginComponent, AccessDeniedComponent],
  providers: [
    AuthGuard,
    { provide: ErrorHandler, useClass: RollbarErrorHandler },
    { provide: RollbarService, useFactory: rollbarFactory }
  ]
})
export class CoreModule { }
